import React from 'react';
import { SuccessMessage } from './elements';

const SuccessMessageCmp = ({ className, isVisible, message }) =>
  isVisible ? <SuccessMessage className={className}>{message}</SuccessMessage> : null;

export default SuccessMessageCmp;
